<template>
    <div class='selectBar mb-4'>
        <div class="flex items-center">
            <select-all />

            <component v-for="(action, index) in selectActions" :key="action.value" :is="action.component" />
        </div>

        <div v-if="isPageSelected && !isEveryItemSelected" class="bg-gray-100 p-4 rounded-lg flex items-center justify-between mt-2 border">
            <p class="text-gray-800 font-semibold">
                You have selected all {{ itemNounPlural }} on this page.
            </p>
            <a @click.prevent="selectAllInView" class="text-blue-600 hover:text-blue-800 font-semibold cursor-pointer" v-if="!loadingSelectAll">
                Select all {{totalFormatted}} {{ itemNounPlural }} in this view
            </a>
            <div class='text-center' v-else style="width: 300px;">
                <font-awesome-icon icon="spinner" class="fa-spin  text-blue-600 text-2xl"></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';
import SelectableInput from './SelectableInput.vue';
import _ from 'lodash';

import SelectAll from './SelectAll.vue';

export default {
    name: 'SelectBar',
    components: {
        SelectAll,
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['selectAll',]),
        selectAllInView() {
            this.selectAll();
        }
    },
    computed: {
        ...mapWritableState(useGeneralTableStore, ['selected', 'page', 'data', 'items', 'total', 'itemNounPlural', 'totalFormatted', 'loadingSelectAll', 'selectActions']),
        isEveryItemSelected() {
            return this.selected.length == this.total;
        },
        id() {
            //see if the first item uses tra_id or not
            return this.items.length ? this.items[0].tra_id ? 'tra_id' : 'id' : 'id';
        },
        isPageSelected() {
            if (!this.items.length || !this.selected.length) return false;
            return this.items.every(item => this.selected.find(selectedItem => selectedItem[this.id] == item[this.id]));
        },
    }
}


</script>